import {Api} from './config/request';

const getAllReportsReq = (crmLsqId) => (Api.getFliveRequest(`report/${crmLsqId}`, true));

export const ReportApiCalls = {
    getAllReportsReq
}
